const galleryItems = [
  {
    src: "/images/hospital/pharmacy-counter.webp",
    caption: "Stainless Pharmacy Dispensing Counter",
    span: "col-span-2",
  },
  {
    src: "/images/hospital/cabinets.webp",
    caption: "Medicine Storage Cabinets",
    span: "col-span-1",
  },
  {
    src: "/images/hospital/mortuary-lab.webp",
    caption: "Mortuary & Lab Equipment",
    span: "col-span-1",
  },
  {
    src: "/images/hospital/trolleys.webp",
    caption: "Theatre Instrument Trolleys",
    span: "col-span-1",
  },
  {
    src: "/images/hospital/nurse-station.webp",
    caption: "Curved Stainless Nurse Station",
    span: "col-span-2",
  },
  {
    src: "/images/hospital/sterile-shelving.webp",
    caption: "Sterile Store Shelving System",
    span: "col-span-1",
  },
];

export default function HospitalGallery() {
  return (
    <section id="gallery" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-teal-600 text-xs font-bold uppercase tracking-widest">Our Work</span>
          <h2 className="text-gray-900 text-3xl md:text-4xl font-extrabold mt-3 uppercase tracking-tight">
            Project Gallery
          </h2>
          <p className="text-gray-500 text-sm mt-4 leading-relaxed">
            A selection of hospital and pharmacy equipment installations completed across Kenya's leading healthcare institutions.
          </p>
        </div>

        {/* Masonry Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {galleryItems.map((item) => (
            <div key={item.src} className={`relative overflow-hidden rounded-lg group ${item.span}`}>
              <img
                src={item.src}
                alt={item.caption}
                className="w-full h-64 object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                <p className="text-white text-xs font-semibold uppercase tracking-wide">{item.caption}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
